export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];

  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

export const listMapper = collection => {
  let result = '';

  switch (collection) {
    case 'notContactedList':
      result = 'Not Contacted';
      break;
    case 'contactedList':
      result = 'Contacted';
      break;
    case 'interviewingList':
      result = 'Interviewing';
      break;
    case 'offeredEmploymentList':
      result = 'Offered Employment';
      break;
    case 'employedList':
      result = 'Employed';
      break;
    case 'noLongerInterestedList':
      result = 'No Longer Interested';
      break;
    case 'notInConsiderationList':
      result = 'Not in Consideration';
      break;

    default:
      break;
  }

  return result;
};

export const statusMapper = status => {
  let result = '';

  switch (status) {
    case '6':
      result = 'Active';
      break;

    default:
      result = 'def';
      break;
  }

  return result;
};

export function logger(strings, ...values) {
  let str = '';

  for (let i = 0; i < strings.length; i++) {
    if (i > 0) {
      if (values[i - 1] && typeof values[i - 1] == 'object') {
        if (values[i - 1] instanceof Error) {
          if (values[i - 1].stack) {
            str += values[i - 1].stack;
            continue;
          }
        } else {
          try {
            str += JSON.stringify(values[i - 1]);
            continue;
          } catch (error) {
            throw error;
          }
        }
      }
      str += values[i - 1];
    }
    str += strings[i];
  }
  console.log(str);

  return str;
}

export function localStorageHelper() {
  localStorage.removeItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`);
  localStorage.removeItem('acc');
  localStorage.removeItem('mainSearch');
}

export function debounce(fn, delay) {
  let timeoutID = null;
  return function() {
    clearTimeout(timeoutID);
    let args = arguments;
    let that = this;
    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
}
